<template>
  <transition :name="name" :mode="mode">
    <slot />
  </transition>
</template>

<script lang="ts">
/**
 * CTransition
 *
 * [Props]
 * mode: in-out|out-in
 *
 */

import Vue from 'vue';

export default Vue.extend({
  name: 'CTransition',
  props: {
    name: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
    },
  },
});
</script>

<style lang="scss" scoped>
// fade-fast
.fade-fast-enter-active,
.fade-fast-leave-active {
  transition: opacity 0.1s;
}
.fade-fast-enter, .fade-fast-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

// fade-normal
.fade-normal-enter-active,
.fade-normal-leave-active {
  transition: opacity 0.3s;
}
.fade-normal-enter, .fade-normal-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

// fade-slow
.fade-slow-enter-active,
.fade-slow-leave-active {
  transition: opacity 0.8s;
}
.fade-slow-enter, .fade-slow-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.slide-right-enter-active,
.slide-right-leave-active {
  //transition: opacity 1s, transform 1s;
  transition: transform 0.5s;
}

.slide-right-enter-to,
.slide-right-leave {
  transform: translateX(0);
}

.slide-right-enter,
.slide-right-leave-to {
  //opacity: 0;
  transform: translateX(100%);
}
</style>
